import React from "react";
import { Link } from "react-router-dom";

import Song from "../song/song";

import "./featured-song.scss";

import { getFeaturedSong } from "./featured-song-fn"; 

function FeaturedSong() {
    var featuredSong = getFeaturedSong();
    
    return (
        <div className="featured-song">
            <h3 className="title">Featured Song</h3>
            <div className="featured-song-container">
                <Song song={featuredSong} />
                <p className="music-link-text">
                    See the songs we play&nbsp;
                    <Link reloadDocument 
                        to='/music' 
                        target="_self">here
                    </Link>
                </p>
            </div>
        </div>
    );
}

export default FeaturedSong;